export default __webpack_public_path__ + "static/media/Queens School of Religion.75ae017d.jfif";